import Polyglot, { type PolyglotOptions } from 'node-polyglot';
import es from '../../locales/es.json';

const polyglots: Map<string, Polyglot> = new Map();

[
    { locale: 'es', values: es, options: {} as PolyglotOptions },
    // { locale: 'pt', values: pt, options: {} as PolyglotOptions },
].forEach((lang) => {
    const polyglot = new Polyglot(lang.options);
    polyglot.extend(lang.values);
    polyglots.set(lang.locale, polyglot);
});

export const translate = (key: string, locale: string, count: number = 1): string => {
    return polyglots.get(locale)?.t(key.trim(), { smart_count: count }) ?? key;
};

export const t = (key: string, count: number = 1): string => {
    // TODO: Get locale from localStorage
    return translate(key, 'es', count);
};
